module.exports = __webpack_public_path__ + "98d82f798ef9337362857887531ef2c5.svg";